import { useEffect, useState, useContext } from 'react';
import { CustomCohesionContext } from 'ui/providers/cohesion';
import requestMonarch from 'ui/js/helpers/monarch';
import { Pricing } from '../../types/common';

export const usePricing = (bakedPricing: Pricing) => {
  const { cohesionReady } = useContext( CustomCohesionContext );
  const [ pricing, setPricing ] = useState(bakedPricing);
  const [ monarchRequestSucceeded, setMonarchRequestSucceeded ] = useState(false);

  useEffect( () => {
    if ( ! cohesionReady || monarchRequestSucceeded ) return;

    // @ts-ignore:next-line
    requestMonarch( 'rule', 'lpPricing', {}, {}, ( result ) => {
      if ( result?.lpPricing ) {
        setPricing( result.lpPricing );
        setMonarchRequestSucceeded( true );
      }
    } );
  }, [ cohesionReady, monarchRequestSucceeded ] );

  return pricing;
};

export default usePricing;
